"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("@xenodrive/vue-map-sdk/config");
exports.default = (0, config_1.defineMapConfig)({
    baseLayers: ['emap:flat'],
    baseLayerOverrides: {
        'emap:flat': {
            minZoom: 4,
        },
    },
    emapOptions: {
        loader: false,
    },
    sprites: {
        default: {
            src: '/storage/assets/img/movement-sprite.png',
            srcSize: [512, 512],
            icons: {
                vehicle_active: [7, 207, 36, 36],
                vehicle_selected: [57, 207, 36, 36], // for selected
                vehicle_inactive: [107, 207, 36, 36],
                person_active: [7, 257, 36, 36],
                person_selected: [57, 257, 36, 36], // for selected
                person_inactive: [107, 257, 36, 36],
                arrow: [200, 200, 50, 50, 0.5, 1.1],
            },
        },
    },
});
